import React, { useEffect } from "react";
import Layout from '../components/layout';
import BackgroundImage from "../assets/images/glossary/ingredients.jpg";
import Breadcrumbs from '../components/breadcrumbs';
import { Helmet } from "react-helmet-async";
import ogImage from "../assets/images/og/molu-banner-1200x630.png";

const ingredients = [
  {
    name: "2-Deoxy-D-Ribose",
    purpose: "Stimulates hair follicle activity by increasing cellular energy and inducing angiogenesis, promoting hair growth at the root."
  },
  {
    name: "2-Phenoxyethanol",
    purpose: "Acts as a gentle preservative to ensure product stability and extend shelf life without irritating the scalp."
  },
  {
    name: "Angiogenesis",
    purpose: "The process through which new blood vessels form, improving blood supply to hair follicles and supporting healthy growth."
  },
  {
    name: "Chelate",
    purpose: "A chemical property that allows an ingredient to bind with metal ions, preventing their interference with active ingredients."
  },
  {
    name: "Citric Acid",
    purpose: "Used to adjust the pH of the gel to match the scalp's natural acidity, ensuring comfort and effectiveness. It also helps maintain 2-Deoxy-D-Ribose in its most active linear form."
  },
  {
    name: "Copper Peptides (GHK-Cu)",
    purpose: "A naturally occurring peptide complex that may support follicle signaling pathways and help maintain healthy hair growth cycles. Research suggests copper peptides play important roles in tissue remodeling and cellular communication processes."
  },
  {
    name: "GHK-Cu (Copper Tripeptide-1)",
    purpose: "A bioactive peptide that research indicates may help activate dormant follicles and support the natural hair growth phase. Studies suggest it may influence follicle size and enhance tissue regeneration processes around hair follicles."
  },
  {
    name: "Magnesium Ascorbyl Phosphate",
    purpose: "A stable form of vitamin C that supports collagen production and protects hair follicles from oxidative stress."
  },
  {
    name: "Oxidative Stress",
    purpose: "An imbalance between free radicals and antioxidants in the body that can lead to hair follicle damage; ingredients in the gel help counteract this."
  },
  {
    name: "Propylene Glycol",
    purpose: "Serves as a humectant that helps retain moisture in the scalp and enhances the penetration of active ingredients."
  },
  {
    name: "Sodium Alginate",
    purpose: "Acts as a natural thickening agent to help the gel maintain its consistency and spread evenly on the scalp. It also supports the effective delivery of the active ingredient to the follicles."
  },
  {
    name: "Sodium Gluconate",
    purpose: "Functions as a chelating agent to improve the stability and performance of other active ingredients."
  },
  {
    name: "Sodium Lactate & Pyruvate Complex",
    purpose: "A metabolic pathway support complex inspired by research on follicle stem cell activity. Studies suggest lactate may play a role in supporting the natural hair growth cycle, while pyruvate supports cellular energy production processes."
  }
];

const Glossary = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Layout>
        <Helmet prioritizeSeoTags>
          {/* Basic SEO */}
          <title>Best Copper Peptides for Hair Growth | Molu Hair Growth Serum</title>
          <meta
            name="description"
            content="Boost hair strength with Molu Hair Growth’s peptide serum — the best copper peptides for faster, thicker hair."
          />
          <meta
            name="keywords"
            content="best copper peptides for hair growth, peptide serum"
          />
          <link
            rel="canonical"
            href={(typeof window !== "undefined" ? window.location.origin : "https://example.com") + "/"}
          />

          {/* Open Graph */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Best Copper Peptides for Hair Growth | Molu Hair Growth Serum" />
          <meta property="og:description" content="Boost hair strength with Molu Hair Growth’s peptide serum — the best copper peptides for faster, thicker hair." />
          <meta property="og:image" content={ogImage} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:url" content={(typeof window !== "undefined" ? window.location.href : "")} />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Best Copper Peptides for Hair Growth | Molu Hair Growth Serum" />
          <meta name="twitter:description" content="Boost hair strength with Molu Hair Growth’s peptide serum — the best copper peptides for faster, thicker hair." />
          <meta name="twitter:image" content={ogImage} />
        </Helmet>
        <section
          className="bg-img1 txt-center p-lr-15 p-tb-92"
                style={{ backgroundImage: `url(${BackgroundImage})` }}
        >
          <h2 className="ltext-105 cl0 txt-center">Ingredient Glossary</h2>
        </section>

        <div className="container">
          <Breadcrumbs />

          <section className="p-t-40 p-b-120">
            <div className="row">
              {ingredients.map((item, index) => (
                <div key={index} className="col-md-6 col-lg-4 p-b-30">
                  <div className="bor16 p-4 h-full shadow-sm">
                    <h4 className="mtext-108 cl2 p-b-12">{item.name}</h4>
                    <p className="stext-113 cl6">{item.purpose}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </Layout>
    </div>
  );
};

export default Glossary;